"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChurnZeroService = void 0;
var axios_1 = __importDefault(require("axios"));
var ChurnZeroService = /** @class */function () {
  function ChurnZeroService() {}
  ChurnZeroService.setChurnZeroAppKey = function (appKey) {
    if (ChurnZeroService.churnZeroLoaded()) {
      window.ChurnZero.push(['setAppKey', appKey]);
    }
  };
  ChurnZeroService.setChurnZeroContact = function (contactId, contactEmail, uuid, firstName, lastName, role) {
    if (ChurnZeroService.churnZeroLoaded() && !/@teamsnap.com\s*$/.test(contactEmail)) {
      var ChurnZero = window.ChurnZero;
      ChurnZero.push(['setContact', contactId, contactEmail]);
      if (firstName) {
        ChurnZero.push(['setAttribute', 'contact', 'FirstName', firstName]);
      }
      if (lastName) {
        ChurnZero.push(['setAttribute', 'contact', 'LastName', lastName]);
      }
      if (uuid) {
        ChurnZero.push(['setAttribute', 'contact', 'PersonId', uuid]);
      }
      if (role) {
        ChurnZero.push(['setAttribute', 'contact', 'ProductRole', role]);
      }
    }
  };
  ChurnZeroService.setChurnZeroAttribute = function (churnZeroUrl, attributes) {
    if (ChurnZeroService.churnZeroLoaded()) {
      try {
        axios_1.default.post("".concat(churnZeroUrl, "/i"), {
          appKey: attributes.appKey,
          action: 'setAttribute',
          entity: 'contact',
          accountExternalId: attributes.contactId,
          contactExternalId: attributes.contactEmail,
          attr_FirstName: attributes.firstName,
          attr_LastName: attributes.lastName,
          attr_Email: attributes.contactEmail,
          attr_ProductRole: attributes.role,
          attr_PersonId: attributes.uuid
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
      } catch (error) {
        console.error(error);
      }
    }
  };
  ChurnZeroService.trackChurnZeroEvent = function (eventName) {
    if (ChurnZeroService.churnZeroLoaded()) {
      window.ChurnZero.push(['trackEvent', eventName]);
    }
  };
  ChurnZeroService.stop = function () {
    if (ChurnZeroService.churnZeroLoaded()) {
      window.ChurnZero.push(['stop']);
    }
  };
  ChurnZeroService.churnZeroLoaded = function () {
    return typeof window.ChurnZero !== 'undefined';
  };
  return ChurnZeroService;
}();
exports.ChurnZeroService = ChurnZeroService;